import {
  AfterContentInit,
  Component, ComponentFactoryResolver,
  ContentChildren,
  EventEmitter,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChild
} from '@angular/core';
import {CommonModule} from "@angular/common";
import {SwitchBoard} from "../services/SwitchBoard";
import {TpiqWindowsComponent} from "../tpiq-windows/tpiq-windows.component";
import {DynamicWindows} from "../directives/dynamic-windows.directive";

declare let _: any;

@Component({
  selector: 'app-windows',
  standalone: true,
  imports: [CommonModule, TpiqWindowsComponent, DynamicWindows],
  templateUrl: './windows.component.html',
  styleUrl: './windows.component.scss'
})
export class WindowsComponent implements AfterContentInit, OnInit, OnDestroy {
  dynamicWindows: TpiqWindowsComponent[] = [];
  destroy$: EventEmitter<void> = new EventEmitter<void>();

  @ContentChildren(TpiqWindowsComponent) windows: QueryList<TpiqWindowsComponent>;

  @ViewChild(DynamicWindows) dynamicWindowPlaceholder: DynamicWindows;

  constructor(private _componentFactoryResolver: ComponentFactoryResolver, private switchBoard: SwitchBoard) {}


  ngAfterContentInit() {

  }

  ngOnInit(): void {

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  openWindow(title: string, template, data, isCloseable = false) {
    const existing = _.find(this.dynamicWindows, function(window){
      return window.dataContext.id === data.id;
    });

    if (!existing){
      if (this.dynamicWindows.length === 3){
        this.dynamicWindows.splice(0, 1);
        const viewContainerRef = this.dynamicWindowPlaceholder.viewContainer;
        viewContainerRef.remove(0);
        this.dynamicWindows.forEach(window => (window.reArrangeStyle()));
      }
      // get a component factory for our WindowComponent
      const componentFactory = this._componentFactoryResolver.resolveComponentFactory(
        TpiqWindowsComponent
      );

      // fetch the view container reference from our anchor directive
      const viewContainerRef = this.dynamicWindowPlaceholder.viewContainer;

      // create a component instance
      const componentRef = viewContainerRef.createComponent(componentFactory);

      // set the according properties on our component instance
      const instance: TpiqWindowsComponent = componentRef.instance as TpiqWindowsComponent;
      instance.title = title;
      instance.template = template;
      instance.dataContext = data;
      instance.isCloseable = isCloseable;
      instance.maximize = true;
      instance.right = (this.dynamicWindows.length * 23) + 7;

      componentRef.instance.onCloseWindow.subscribe($event => {
        this.childWindowClosed($event);
      });

      componentRef.instance.onCall.subscribe($event => {
        // this.createCall($event);
      });

      componentRef.instance.onWindowMaximize.subscribe($event => {
        this.childWindowmaximized($event);
      });
      // window navigation headers
      this.dynamicWindows.push(componentRef.instance as TpiqWindowsComponent);
      this.dynamicWindows.forEach(window => {
        if (window.dataContext.id != data.id) {
          window.minimizeWindow();
        }
      });
    }else {
      this.dynamicWindows.forEach(window => {
        if (window.dataContext.id === data.id){
          window.maximizeWindow();
        }else {
          window.minimizeWindow();
        }
      });
    }
  }

  closeAllWindows(){
    for (let i = 0; i < this.dynamicWindows.length; ++i) {
      const viewContainerRef = this.dynamicWindowPlaceholder.viewContainer;
      viewContainerRef.remove(i);
    }
    this.dynamicWindows = [];
  }

  childWindowClosed(ev){
    let reArrange = false;
    for (let i = 0; i < this.dynamicWindows.length; i++) {
      if (this.dynamicWindows[i].dataContext.id === ev.id) {
        // remove the window from our array
        this.dynamicWindows.splice(i, 1);
        // destroy our dynamically created component again
        const viewContainerRef = this.dynamicWindowPlaceholder.viewContainer;
        viewContainerRef.remove(i);
        if (i != 2){
          reArrange = true;
        }
        break;
      }
    }
    setTimeout(() => {
      if (reArrange){
        this.dynamicWindows.forEach(tab => (tab.reArrangeStyle()));
      }
    });
  }

  // createCall(data){
  //   this.switchBoard.windowCall.next(data.id);
  // }

  childWindowmaximized(ev){
    this.dynamicWindows.forEach(window => {
      if (window.dataContext.id !== ev.id){
        window.minimizeWindow();
      }
    });
  }

  minimizeAllWindows(){
    this.dynamicWindows.forEach(window => {
      window.minimizeWindow();
    });
  }

}
